import { DocsGuide } from "@/types/docs-guides";

import body from "./body.mdx";

const collisionEvents: DocsGuide = {
  title: "Getting Started: MML with React",
  // Give me a better description
  description: "Composability, reusability, and extensibility made easy.",
  body,
  linkList: [
    "Why React?",
    "How to",
    "Your First React Component",
    "Reusability with React",
    "MML Events in React",
    "Collision Events",
    "Position Probe Events",
    "Animating on Click",
    "Animating on Collision",
    "Resources",
  ],
};

export default collisionEvents;
